module.exports = __webpack_public_path__ + "img/dropdown-triangle.fa7ae2c9.svg";